import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import ChildrenPropType from 'lib/CustomPropTypes/children';

function OneByOne(props) {
  const { children, id } = props;

  return (
    <div
      className={classNames(
        'bacon-cards-onebyone',
        'w-100',
        'overflow-hidden',
      )}
      data-test="one-by-one__container"
      data-contentid={id}
    >
      {children}
    </div>
  );
}

OneByOne.contextTypes = {
  vertical: PropTypes.string,
};

OneByOne.propTypes = {
  children: ChildrenPropType,
  id: PropTypes.string.isRequired,
};

OneByOne.defaultProps = {
  children: '',
};

export default OneByOne;
